import { render, staticRenderFns } from "./TypingLoader.vue?vue&type=template&id=2fae2410&scoped=true&lang=pug"
import script from "./TypingLoader.js?vue&type=script&lang=js&external"
export * from "./TypingLoader.js?vue&type=script&lang=js&external"
import style0 from "./TypingLoader.vue?vue&type=style&index=0&id=2fae2410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae2410",
  null
  
)

export default component.exports